import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from '../pages/Home';
import AboutUs from '../pages/AboutUs'; 
import ContactUs from '../pages/ContactUs';
// import ApplyForLoan from '../components/apply-for-loan';
import TermsAndConditions from '../components/terms&conditions';
import PrivacyPolicy from '../components/privacy-policy'; 
import CorporateGovernancePage from '../pages/CorporateGovernancePage';
import FairPracticeCodePage from '../pages/FairPracticeCodePage';
import KycAndPmlaPage from '../pages/KycAndPmlaPage';
import RiskManagementPolicyComponent from '../components/risk-management-policy';
import TermsRatesComponent from '../components/terms-rates';
import Faqs from '../components/faqs'; 
import InterestRatePolicy from '../components/interest-rate-policy';
import RepayLoan from '../pages/RepayLoan';
import KeyFactStatement from '../components/key-fact-statement';
import ApplyNow from '../components/apply-now';
import ApplyLoan from '../components/apply-loan';
import VideoKYC from '../components/video-kyc';
import Check from '../components/check';
import GetPanVerify from '../components/getpanverify';
import ThankYou from "../components/ApplyNowSteps/ThankYou";
import PaymentSuccess from '../components/PaymentSuccess';
import LandingPage from '../pages/LandingPage';
import AggregatorThankYou from '../pages/AggregatorThankYou';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/landing" element={<LandingPage />} />
      <Route path="/thank-you-aggregator" element={<AggregatorThankYou />} />
      <Route path="/aggregator/thank-you" element={<AggregatorThankYou />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/terms-conditions" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/corporate-governance" element={<CorporateGovernancePage />} />
      <Route path="/fair-practice-code" element={<FairPracticeCodePage />} />
      <Route path="/interest-rate-policy" element={<InterestRatePolicy />} />
      <Route path="/kyc-and-pmla" element={<KycAndPmlaPage />} />
      <Route path="/risk-management-policy" element={<RiskManagementPolicyComponent />} />
      <Route path="/terms-rates" element={<TermsRatesComponent />} />
      <Route path="/faqs" element={<Faqs />} />
      <Route path="/repay-loan" element={<RepayLoan />} />
      <Route path="/key-fact-statement" element={<KeyFactStatement />} />
      <Route path="/apply-now" element={<ApplyNow />} />
      <Route path="/apply-loan" element={<ApplyLoan />} />
      <Route path='/video-kyc' element={<VideoKYC />} />
      <Route path='/check' element={<Check />} />
      <Route path='/getpanverify' element={<GetPanVerify />} />
      <Route path="/thank-you" element={<ThankYou />} />
      {/* PayU / PayTM return — backend redirects here with ?response=&respcode= */}
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/PaymentSuccess" element={<PaymentSuccess />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="*" element={<div><h2>404 - Page Not Found</h2></div>} />
    </Routes>
  );
};

export default AppRoutes;
